import React from 'react';
import SectionRow from './SectionRow';
import SummaryRow from './SummaryRow';
import SsrsComparativeRow from './SsrsComparativeRow';
import { GenericRowType } from '../../../types/ancillaryCostTableRowTypes';

interface props {
  row: GenericRowType;
  index: string;
  surchargeValues: { [key: string]: string };
  rebooking: boolean | undefined;
  totalCost: number;
  handleInputChange: (id: any, value: any) => void;
  commonStyles: any;
  uniqueRows: any;
  showAdjustedSurcharge: boolean | undefined;
}

const AncillaryCostTableRows: React.FC<props> = ({
  row,
  index,
  surchargeValues,
  rebooking,
  totalCost,
  handleInputChange,
  commonStyles,
  uniqueRows,
  showAdjustedSurcharge,
}) => {
  if (row.isSection) {
    return <SectionRow row={row} index={index} commonStyles={commonStyles} />;
  } else if (row.isSummary) {
    return (
      <SummaryRow
        row={row}
        index={index}
        uniqueRows={uniqueRows}
        commonStyles={commonStyles}
        totalCost={totalCost}
        surchargeValues={surchargeValues}
        rebooking={rebooking}
        showAdjustedSurcharge={showAdjustedSurcharge}
      />
    );
  } else {
    return (
      <SsrsComparativeRow
        row={row}
        index={index}
        commonStyles={commonStyles}
        rebooking={rebooking}
        surchargeValues={surchargeValues}
        handleInputChange={handleInputChange}
        showAdjustedSurcharge={showAdjustedSurcharge}
      />
    );
  }
};

export default AncillaryCostTableRows;
